import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  Paper,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import Layout from '../layout';
import { showError, showSuccess } from '../../../components/notifications';
import api from '../../../api/axiosInstance';
import { EnableNotificationsButton } from '../../../components/pwaNotifications/enableNotificationsButton';
import { NotificationPreviewButton } from '../../../components/pwaNotifications/notificationsPreview';

function Profile() {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleSubmit = async () => {
    try {
      if (newPassword.length < 6) {
        showError('Новый пароль должен быть не менее 6 символов');
        return;
      }

      await api.post('/auth/change-password', {
        oldPassword,
        newPassword,
      });

      showSuccess('Пароль успешно изменён');
      setOldPassword('');
      setNewPassword('');
    } catch (err: any) {
      showError(err?.response?.data?.message || 'Ошибка при изменении пароля');
    }
  };

  return (
    <Layout>
      <Box maxWidth="md" mx="auto" mt={3} display="flex" flexDirection="column" gap={3}>
        <Paper elevation={3} sx={{ p: 3 }}>
          <Typography variant="h6" mb={2}>
            Смена пароля
          </Typography>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel htmlFor="old-password">Старый пароль</InputLabel>
            <Input
              id="old-password"
              type="password"
              value={oldPassword}
              onChange={e => setOldPassword(e.target.value)}
            />
          </FormControl>

          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel htmlFor="new-password">Новый пароль</InputLabel>
            <Input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
            />
            <FormHelperText>Минимум 6 символов</FormHelperText>
          </FormControl>

          <Button variant="contained" fullWidth onClick={handleSubmit}>
            Изменить пароль
          </Button>
        </Paper>

        <Paper elevation={3} sx={{ p: 3 }}>
          <Typography variant="h6" mb={2}>
            Уведомления
          </Typography>

          <Typography variant="body2" mb={2} sx={{ opacity: 0.7 }}>
            Включите push-уведомления на этом устройстве
          </Typography>

          <Box display="flex" flexDirection="column" gap={1.5}>
            <EnableNotificationsButton />
            <NotificationPreviewButton />
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
}

export default Profile;
